import { cva } from "class-variance-authority";

export { default as ButtonGroup } from "./ButtonGroup.vue";
export { default as ButtonGroupItem } from "./ButtonGroupItem.vue";

export const sizes = ["sm", "md"];

export const variants = cva(
    [
        "inline-flex",
        "border",
        "border-primary",
        "rounded-md",
        "shadow-xs",
        "overflow-hidden",
    ],
    {
        variants: {
            size: {
                sm: ["h-7.5", "text-xs"],
                md: ["h-10", "text-sm"],
            },
        },
        defaultVariants: {
            size: "md",
        },
    }
);

export const buttonVariants = cva(
    [
        "inline-flex",
        "items-center",
        "justify-center",
        "shrink-0",
        "py-2",
        "px-2",
        "gap-2",
        "focus:text-secondary",
        "hover:text-secondary_hover",
        "disabled:text-disabled",
        "font-semibold",
        "border-r",
        "ltr:border-r",
        "rtl:border-l",
        "last:border-r-0",
        "ltr:last:border-r-0",
        "rtl:last:border-l-0",
        "border-primary",
        "[&>svg]:w-4",
        "[&>svg]:h-4",
        "disabled:[&>svg]:fg-disabled",
        "transition-colors",
        "cursor-pointer",
        "h-full",
    ],
    {
        variants: {
            size: {
                sm: ["text-style-xs"],
                md: ["text-style-sm"],
            },
            icon: {
                true: ["px-3"],
            },
            active: {
                false: ["focus:bg-active", "fg-quaternary", "bg-secondary"],
                true: ["focus:bg-active", "fg-primary", "bg-primary"],
            },
        },
        defaultVariants: {
            size: "md",
            icon: false,
            active: false,
        },
    }
);
